"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-popover", {
    attrs: {
      trigger: "click"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c("a-tabs", {
          staticClass: "w-[200px]"
        }, [_c("a-tab-pane", {
          key: "read",
          attrs: {
            tab: "已读"
          }
        }, [_c("div", {
          staticClass: "size-[200px] overflow-scroll flex flex-col gap-2"
        }, _vm._l(_vm.readList, function (user) {
          return _c("div", {
            key: user.id
          }, [_c("a-avatar", {
            attrs: {
              size: 30,
              src: user.avatar
            }
          }, [!user.avatar ? [_vm._v(_vm._s(user.userName))] : _vm._e()], 2), _vm._v(" " + _vm._s(user.userName) + " ")], 1);
        }), 0)]), _c("a-tab-pane", {
          key: "unread",
          attrs: {
            tab: "未读"
          }
        }, [_c("div", {
          staticClass: "size-[200px] overflow-scroll flex flex-col gap-2"
        }, _vm._l(_vm.unreadList, function (user) {
          return _c("div", {
            key: user.id
          }, [_c("a-avatar", {
            attrs: {
              size: 30,
              src: user.avatar
            }
          }, [!user.avatar ? [_vm._v(_vm._s(user.userName))] : _vm._e()], 2), _vm._v(" " + _vm._s(user.userName) + " ")], 1);
        }), 0)])], 1)];
      },
      proxy: true
    }])
  }, [_c("a-button", {
    attrs: {
      type: "link"
    }
  }, [_vm._v(_vm._s(_vm.messageReadUserStr))])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;